import Container from '@/container';
import {Col, Grid, Row} from '@/grid';
import {withBgYellow50} from '@/hocs/withColors';
import {withMarginBottomSm, withMarginBottomXxl} from '@/hocs/withSpacing';
import {SectionPadding} from '@/section';
import {H2, H3, PNoMargin} from '@/typography';
import BoxGrid from '@/ui/box-grid';
import {GridItem, GridLayout} from '@/ui/grid/grid-layout';
import PictureWrapper from '@/ui/images-wrapper';
import Pill from '@/ui/pills';

const Yellow50Section = withBgYellow50(SectionPadding);
const PillMargined = withMarginBottomSm(Pill);
const H2MarginedBottomXxl = withMarginBottomXxl(H2);

const imgPath = '/static/images/partnership-program/technology-partners/partner-with-us/';

const PartnerWithUsSection = () => (
  <Yellow50Section>
    <Container>
      <Grid fluid>
        <Row center="xs">
          <Col xs={12} lg={6}>
            <PillMargined variant="neutral900">Partner with us</PillMargined>
            <H2MarginedBottomXxl>Help your clients build great teams, faster</H2MarginedBottomXxl>
          </Col>
        </Row>
        <GridLayout Col={3} lgCol={2} autoRows>
          <GridItem Col={1} Row={1}>
            <BoxGrid backgroundColor="var(--yellow100)">
              <H3>Find and attract candidates</H3>
              <PNoMargin>
                Fill your pipeline quickly with one-click job posting to 200+ sites, AI-powered
                sourcing, employee referrals and more.
              </PNoMargin>
            </BoxGrid>
          </GridItem>
          <GridItem Col={1} Row={1}>
            <BoxGrid backgroundColor="var(--yellow100)">
              <H3>Move the right applicants forward</H3>
              <PNoMargin>
                Collaborate with hiring teams to evaluate applicants, gather feedback and decide
                who's best, all in one recruiting system.
              </PNoMargin>
            </BoxGrid>
          </GridItem>
          <GridItem Col={1} Row={1}>
            <PictureWrapper
              imgPath={imgPath}
              imageUrl="customer-support"
              imageTypeFallback="jpg"
              alt="Customer support"
            />
          </GridItem>
          <GridItem Col={2} Row={2}>
            <PictureWrapper
              imgPath={imgPath}
              imageUrl="ai-recruiter"
              imageTypeFallback="jpg"
              alt="Ai recruiter"
            />
          </GridItem>
          <GridItem Col={1} lgCol={2} Row={1}>
            <BoxGrid backgroundColor="var(--yellow100)" minHeight={288}>
              <H3>Make the best hire, in half the time</H3>
              <PNoMargin>
                Move faster on a recruiting and HR platform that automates processes and manual
                tasks, like scheduling interviews and getting approvals.
              </PNoMargin>
            </BoxGrid>
          </GridItem>
          <GridItem Col={1} lgCol={2} Row={1}>
            <PictureWrapper
              imgPath={imgPath}
              imageUrl="roles-filled"
              imageTypeFallback="jpg"
              alt="Roles filled"
            />
          </GridItem>
        </GridLayout>
      </Grid>
    </Container>
  </Yellow50Section>
);

export default PartnerWithUsSection;
